<template>
  <div class="w-full grid grid-cols-1 gap-6 lg:grid-cols-2 items-center">
    <div :class="contentOrderClass">
      <slot name="copyBlockRequired">
        <component :is="renderCustomElements(copyBlockRequired)" />
      </slot>
    </div>
    <div :class="imageOrderClass">
      <template v-if="!isVideo">
        <slot name="mediaBlock" />
      </template>
      <template v-else>
        <SingleVideoClient
          :video="mediaIsVideo"
          :is-active="isActive"
          @activate-video="isActive = true"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue';
import SingleVideoClient from '@/components/global/paragraph/video/Default.client.vue';
import type { Video } from '~/types';

const { renderCustomElements } = useDrupalCe();

const { copyBlockRequired } = defineSlots<{
  mediaBlock(): any;
  copyBlockRequired(): any;
}>();

const alternateDirection = inject<'1' | '0'>('alternateDirection', '0');
const childCounter = inject<{ value: number }>('alternateChildCounter', ref(0));
const index = childCounter.value++;

const isContentOnLeft = computed((): boolean => {
  const isEven = index % 2 === 0;
  return alternateDirection === '1' ? !isEven : isEven;
});

const contentOrderClass = computed((): string => {
  return isContentOnLeft.value ? 'order-1 lg:me-6' : 'order-2 lg:ms-6';
});

const imageOrderClass = computed((): string => {
  return isContentOnLeft.value ? 'order-2' : 'order-1';
});

const isActive = ref(false);
const slots = useSlots();
const mediaIsVideo = computed<Video | undefined>(() => {
  const mediaSlotNodes = slots.mediaBlock?.() ?? [];
  const mediaNodeVideo = mediaSlotNodes[0]?.props as Video | undefined;
  return mediaNodeVideo;
});

const isVideo = computed((): boolean => Boolean(mediaIsVideo.value?.video));
</script>
